// Sliders met Swiper (los geladen in de layout, globale Swiper): "Blijf op de hoogte" (projectenactualiteitsleider)
// en de fotogalerij. De pijlen worden per slider opgezocht, zodat meerdere sliders op een pagina elk hun eigen pijlen hebben.
declare const Swiper: any;

function arrows(scope: Element | null) {
    return {
        nextEl: scope ? scope.querySelector('.swiper-button-next') : null,
        prevEl: scope ? scope.querySelector('.swiper-button-prev') : null,
    };
}

if (typeof Swiper !== 'undefined') {
    // Blijf op de hoogte: 1 kaart op mobiel en tablet (tekst naast de foto), 2 vanaf 1024px
    for (const el of Array.from(document.querySelectorAll<HTMLElement>('.swiper-actueel .swiper'))) {
        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: arrows(el.closest('.swiper-actueel')),
            breakpoints: {
                320: { slidesPerView: 1, spaceBetween: 20 },
                769: { slidesPerView: 1, spaceBetween: 24 },
                1024: { slidesPerView: 2, spaceBetween: 24 },
            },
        });
    }

    // Fotogalerij: gecentreerd, 3 foto's vanaf 640px
    for (const el of Array.from(document.querySelectorAll<HTMLElement>('.swiper--alt'))) {
        new Swiper(el, {
            direction: 'horizontal',
            centeredSlides: true,
            centeredSlidesBounds: true,
            navigation: arrows(el.closest('.swiper-gallery')),
            breakpoints: {
                320: { slidesPerView: 1, spaceBetween: 20 },
                640: { slidesPerView: 3, spaceBetween: 24 },
            },
        });
    }
}

export {};
